import React from 'react';
import contensis from 'Common/api/contensis';
import cmsParser from 'Common/util/cmsParser';
import setCacheHeaders from 'Common/func/setCacheHeaders';

import type { NextPageWithLayout, GetServerSideProps } from 'next';

import Metadata from 'Components/Metadata';
import MainLayout from 'Layout/Main';
import Template, { datamap, PageData } from 'Templates/Staff/Profile/GovernorAndProfessional';

const ProfessionalProfile: NextPageWithLayout<PageData> = ({ entry, ancestors }) => {
    return (
        <>
            <Metadata {...cmsParser.metadata(entry)} />
            <Template {...datamap({ entry, ancestors })} />
        </>
    );
};

ProfessionalProfile.getLayout = (page, props) => {
    return <MainLayout {...props}>{page}</MainLayout>;
};

export const getServerSideProps: GetServerSideProps<any> = async ({ params, preview, res }) => {
    const { profile } = params as { profile: string };
    const { fetch, surrogateKeys } = contensis({ preview, fetchSurrogateKeys: true });
    const { data, error } = await fetch(async client => {
        const resPage = await client.nodes.get({
            path: `/staff/professional/${profile}`,
            entryLinkDepth: 4,
            entryFields: [
                'title',
                'sys',
                'id',
                'uri',
                'contentTypeId',
                // heroBanner
                'staffMember',
                'jobTitle',
                'honorific',
                'postnominalTitles',
                'person',
                'forename',
                'surname',
                'department',
                'picture',
                'email',
                'hideEmail',
                'phoneNumber',
                'room',
                'socialMediaLink',
                // role
                'roleHeading',
                'roleContent',
                // experience
                'experienceHeading',
                'experienceContent',
                // qualifications
                'qualificationHeading',
                'qualificationContent',
                // externalBodies
                'externalBodiesHeading',
                'externalBodiesContent',
                // committeeMemberships
                'committeeMembershipHeading',
                'committeeMembershipContent',
                // pageMetadata
                'pageMetadata',
                'customTitle',
                'description',
                'keywords',
                'noIndexing',
                'canonical'
            ]
        });

        if (!resPage.entry || !resPage.entry.staffMember?.person) {
            return { error: true };
        }

        const ancestors = await client.nodes.getAncestors({
            id: resPage.id,
            entryFields: ['title']
        });

        return {
            entry: resPage.entry,
            ancestors
        };
    });

    if (error) {
        return { notFound: true };
    } else {
        setCacheHeaders(res, surrogateKeys);

        return { props: data };
    }
};

export default ProfessionalProfile;
